import { createAction } from 'redux-actions';

import { appendMode } from 'constants/general';
import fetch from 'features/common/fetch';

import * as types from './actionTypes';
import { url } from './constants';

export const setData = (keyWindow) => createAction(types.SET_DATA, (data) => ({ keyWindow, data }));
export const appendData = (keyWindow) => createAction(types.APPEND_DATA, (data) => ({ keyWindow, data }));
export const reset = (keyWindow) => createAction(types.RESET, () => ({ keyWindow }));
export const resetAll = () => createAction(types.RESET_ALL);

const loadData =
	({ keyWindow, append, queryParams, onSuccess }) =>
	(dispatch) => {
		dispatch(
			fetch.actions.get(fetch.constants.urls.campaignList, {
				uniqueReqID: keyWindow,
				queryParams,
				onSuccess: [
					(response) => () => {
						if (onSuccess) return onSuccess(response, append);

						const data = response.body.data;
						if (!data || !Array.isArray(data)) return;

						dispatch(append === appendMode.SET ? setData(keyWindow)(data) : appendData(keyWindow)(data));
					},
				],
			}),
		);
	};

export const load = (keyWindow) => (queryParams, onSuccess) => (dispatch) => {
	dispatch(
		loadData({
			keyWindow,
			append: appendMode.SET,
			queryParams,
			onSuccess,
		}),
	);
};

export const loadSorted = (keyWindow) => (sort) => (dispatch, getState) => {
	const { queryParams, ...rest } = fetch.selectors.getLastRequest(url)(getState());
	dispatch(
		loadData({
			...rest,
			keyWindow,
			append: appendMode.SET,
			queryParams: { ...queryParams, sort },
		}),
	);
};

export const loadMore = (keyWindow) => () => (dispatch, getState) => {
	const { queryParams, ...rest } = fetch.selectors.getLastRequest(url)(getState());
	dispatch(
		loadData({
			...rest,
			keyWindow,
			append: appendMode.APPEND,
			queryParams: { ...queryParams, page: queryParams.page + 1 },
		}),
	);
};

export const loadPage = (keyWindow) => (page) => (dispatch, getState) => {
	const { queryParams, ...rest } = fetch.selectors.getLastRequest(url)(getState());
	dispatch(
		loadData({
			...rest,
			keyWindow,
			append: appendMode.SET,
			queryParams: { ...queryParams, page },
		}),
	);
};

export const reload = (keyWindow) => () => (dispatch, getState) => {
	const lastRequest = fetch.selectors.getLastRequest(url)(getState());
	dispatch(loadData({ ...lastRequest, keyWindow, append: appendMode.SET }));
};
